import React from 'react';
import { formatMoney } from '../../util/currency';

import css from './OrderBreakdown.module.css';

/**
 * Renders the refundable deposit line item.
 * Shows for both customer (they pay it) and provider (they receive it as security).
 * Styled distinctly to indicate it's refundable.
 */
const LineItemRefundableDepositMaybe = props => {
  const { lineItems, intl } = props;
  const item = lineItems.find(i => i.code === 'line-item/security-deposit' && !i.reversal);

  if (!item) return null;

  const label = intl.formatMessage({ id: 'OrderBreakdown.refundableDeposit' });
  const formattedTotal = formatMoney(intl, item.lineTotal);

  return (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        {label}
        <span className={css.depositNote}>
          {intl.formatMessage({ id: 'OrderBreakdown.refundableDepositNote' })}
        </span>
      </span>
      <span className={css.itemValue}>{formattedTotal}</span>
    </div>
  );
};

export default LineItemRefundableDepositMaybe;
